module.exports = __webpack_public_path__ + "images/blnd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/blnd.jpg
// module id = 124
// module chunks = 0